import React from 'react';

export interface BookingContextChip {
  key: string;
  icon?: React.ReactNode;
  label: string;
}

interface BookingWizardContextProps {
  items: BookingContextChip[];
}

/**
 * Compact recap of choices made so far in the booking wizard.
 * Abraxas dark theme styles are forced in base.css (.booking-wizard-context__chip).
 */
export function BookingWizardContext({ items }: BookingWizardContextProps) {
  if (items.length === 0) return null;

  return (
    <div className="mb-3 flex flex-wrap gap-1.5 booking-wizard-context" aria-label="Récapitulatif des choix">
      {items.map((item) => (
        <div
          key={item.key}
          className="booking-wizard-context__chip inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs bg-gray-100 border border-gray-300 text-gray-900"
        >
          {item.icon && (
            <span className="booking-wizard-context__icon flex-shrink-0 text-gray-700 [&>svg]:w-3.5 [&>svg]:h-3.5" aria-hidden>
              {item.icon}
            </span>
          )}
          <span className="font-medium truncate max-w-[10rem] sm:max-w-[14rem]">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
